// extracted by css-extract-rspack-plugin
export default {"cls1":"SplitVerdictPreviewList-cls1_6y6","cls2":"SplitVerdictPreviewList-cls2_-5A SplitVerdictPreviewList-cls1_6y6"};